<template>
  <div class="sort">
    <div class="sort_item blue">{{ text }}</div>
    <div class="sort_item whirt sort_flex">
      <div class="sort_icon"  @click="clickSort">
        <span>总浏览量</span>
        <div class="sort_icon_item">
          <i class="el-icon-caret-top"></i>
          <i class="el-icon-caret-bottom"></i>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
export default {
  name: "Sort",
  props:{
    tabActiveName: {
      default: ()=>'提交时间',
      type: String
    },
    type: {
      default: ()=>1,
      type: Number
    },
    getSortData: {
      default: () => { () => {} },
      type: Function
    },
    tabIndex:{
      default: 0,
      type: Number
    }
  },
  components() {

  },
  data() {
    return {
      text: '提交时间',
      filter: [],
      count: "",
      count2: "",
      flag: false
    }
  },
  created() {

  },
  computed() {

  },
  mounted() {
    
  },
  watch: {
    tabActiveName: {
      handler(newVal) {
        if(["全部" , "待审核"].includes(newVal) ) {
          this.text = "提交时间"
        } else if( ["已通过" , "已驳回"].includes(newVal)) {
          this.text = "审核时间"
        }
      }
    }
  },
  methods: {
    clickSort() {
      const icon = document.getElementById("icon_check");
      if(icon) {
        icon.setAttribute("id","");
      }
      if(!this.count && !this.count2 && !this.flag) {
        const iconTop = document.getElementsByClassName("el-icon-caret-top")[this.tabIndex];
        iconTop.setAttribute("id","icon_check");
        this.filter = [{field:"contentStatistics.browseCount",order:"asc"}];
        this.count = 1
        this.count2 = 1;
      } else if(this.count == 1 && this.count2 == 1 && !this.flag) {
        const iconBottom = document.getElementsByClassName("el-icon-caret-bottom")[this.tabIndex];
        iconBottom.setAttribute("id","icon_check");
        this.filter = [{field:"contentStatistics.browseCount",order:"desc"}];
        this.count = "";
        this.count2 = "";
        this.flag = true
      } else if(this.flag) {
        this.flag = false;
        this.filter = [];
      }
      this.$emit("getSortData", this.filter)
    },

  }
}
</script>

<style lang="scss" scoped>
  .sort {
    display: flex;
    margin-bottom: 10px;
    .sort_item {
      width: 100px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      // font-weight: 600;
      font-size: 18px;
      cursor: pointer;
    }
    .sort_flex {
      display: flex;
      .sort_icon {
        margin-left: 5px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        >span {
          margin-right: 5px;
        }
        .sort_icon_item {
          font-size: 12px;
          display: flex;
          justify-content: space-around;
          flex-direction: column;
        }
      }
    }
    .blue {
      color: #fff;
      background: #409EFF;
    }
    .whirt {
      color: #000;
      border: solid 1px #ccc;
    }
    #icon_check {
      color: #409EFF
    }
  }
</style>